import { useState } from "react";
import {
    Box,
    Button,
    Typography,
    Backdrop,
    CircularProgress,
    Stack
} from "@mui/material";

import QRCode from "qrcode";
import QrCode2Icon from "@mui/icons-material/QrCode2";

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export default function SoldItemsQR({ generatedText }) {
    const [open, setOpen] = useState(false);
    const [qrCode, setQrCode] = useState("");
    const [loading, setLoading] = useState(false);

    const handleGenerateQR = async () => {
        setOpen(true);
        setLoading(true);
        setQrCode("");

        try {
            // Save generated text as a .txt file.
            const response = await fetch(
                `${apiUrl}shared_text/save_qr_text.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        content: generatedText,
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.error || "Failed to save text");
            }

            // QR contains only the link and token.
            const shareUrl = new URL(
                `/copy-text/${result.token}`,
                window.location.origin
            ).href;

            const qr = await QRCode.toDataURL(shareUrl, {
                width: 400,
                margin: 2,
                errorCorrectionLevel: "M",
            });

            setQrCode(qr);

        } catch (error) {
            console.error("Error generating QR code:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <CustomButton
                label="Scan Copy"
                startIcon={<QrCode2Icon />}
                onClick={handleGenerateQR}
            />

            {/* BACKDROP */}
            <Backdrop
                aria-hidden="false"
                open={open}
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backdropFilter: "blur(1px)",
                }}
            >
                {/* PAPER POPUP */}
                <Box
                    sx={{
                        width: "40%",
                        backgroundColor: "#ffffff",
                        borderRadius: 2,
                        p: 2.5,
                        boxShadow: 6,

                        position: "relative",
                        overflow: "hidden",
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "4px",
                            background: "#2e3489"
                        }
                    }}
                >
                    {/* HEADER */}
                    <CustomModalHeader
                        title="Total Sold Items QR Code"
                        subtitle="Scan this QR code using your mobile phone camera."
                        onClose={handleClose}
                    />

                    {loading ? (
                        <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            sx={{ py: 5, width: "100%" }}
                        >
                            <CircularProgress />
                            <Typography sx={{ mt: 2, color: "#94A3B8" }}>
                                Generating QR Code...
                            </Typography>
                        </Stack>
                    ) : (
                        qrCode && (
                            <Box
                                component="img"
                                src={qrCode}
                                alt="Total Sold Items QR Code"
                                sx={{
                                    width: 300,
                                    maxWidth: "100%",
                                    height: "auto",
                                    display: "block",
                                    mx: "auto",
                                }}
                            />
                        )
                    )}

                    {/* CLOSE BUTTON */}
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        sx={{ mt: 2 }}
                    >
                        Close
                    </Button>
                </Box>

            </Backdrop>
        </>
    );
}
